export const areRequiredProofsComplete = (proofPercentage) =>
  proofPercentage === 100;

export const isAssiaSendToManagementDisabled = ({
  proofPercentage,
  loading,
  canSendToManagement,
  isLastSendSuccess,
  isLastSendPending,
  lastSentToManagement,
}) =>
  Boolean(loading) ||
  !canSendToManagement ||
  Boolean(isLastSendSuccess) ||
  Boolean(isLastSendPending) ||
  Boolean(lastSentToManagement) ||
  !areRequiredProofsComplete(proofPercentage);
